import React from "react"
import "./frames.css"

const Transporte = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Métodos de Transporte</h1>

      <h2 className="frames-subtitle">Desde la Fábrica hasta su Destino</h2>
      <p className="frames-text">
        Nos encargamos de todo el proceso de transporte desde la salida de la
        fábrica hasta la sala de destino, asegurando una entrega segura y
        eficiente.
      </p>

      <h2 className="frames-subtitle">Detalles del Proceso</h2>
      <ul className="frames-text">
        <li>Recogida en la fábrica</li>
        <li>Traslado hasta el puerto de embarque o aeropuerto</li>
        <li>Transporte marítimo o aéreo según las necesidades</li>
        <li>
          Embalaje robusto y al vacío para evitar humedades en transporte
          marítimos
        </li>
        <li>
          Envoltura aislante y válvula control de humedad para asegurar la
          integridad del producto
        </li>
        <li>Cajas de madera anti-choque para una mayor seguridad</li>
        <li>Gestiones aduaneras y pago de impuestos</li>
        <li>Traslado al almacén farmacéutico para su trazabilidad</li>
        <li>Transporte hasta la ubicación final</li>
        <li>Colocación en la sala para su puesta en marcha</li>
      </ul>
    </div>
  )
}

export default Transporte
